import { render, staticRenderFns } from "./QueryRootsDetail.vue?vue&type=template&id=bf63e732&scoped=true&"
import script from "./QueryRootsDetail.vue?vue&type=script&lang=js&"
export * from "./QueryRootsDetail.vue?vue&type=script&lang=js&"
import style0 from "./QueryRootsDetail.vue?vue&type=style&index=0&id=bf63e732&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf63e732",
  null
  
)

export default component.exports